<template>
  <v-dialog :value="value" @input="close" width="700" persistent no-click-animation scrollable>
    <v-card>
      <v-toolbar flat height="55">
        <v-toolbar-title class="subtitle-1 text--secondary font-weight-medium">PDF documento de soporte</v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-row align="center" justify="center" class="mr-1">
            <v-btn @click="close" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
          </v-row>
        </v-toolbar-items>
      </v-toolbar>
      <v-divider />
      <v-card-text class="pa-0 background">
        <v-row v-if="loading">
          <v-col cols="12" class="py-16 text-center">
            <v-progress-circular indeterminate color="primary" size="48" />
            <span class="d-block subtitle-2 text--secondary mt-4">Cargando PDF…</span>
          </v-col>
        </v-row>
        <v-row v-else-if="!pdfUrl">
          <v-col cols="12" class="py-16 text-center">
            <v-icon class="d-block" color="secondary" size="70">mdi-image-broken-variant</v-icon>
            <span class="d-block subtitle-1">PDF no disponible</span>
          </v-col>
        </v-row>
        <v-row v-else no-gutters>
          <v-col cols="12">
            <iframe :src="pdfUrl" width="100%" height="640" style="border: 0;" />
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn outlined @click="close">Cerrar</v-btn>
        <v-btn v-if="pdfUrl" :href="pdfUrl" target="_blank" color="primary">Abrir en nueva pestaña</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import GenericViewMixin from '@/mixins/GenericViewMixin'

export default {
  mixins: [GenericViewMixin],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    documentItem: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    loading: false,
    pdfUrl: null,
    objectUrl: null
  }),
  watch: {
    value (open) {
      if (open) {
        this.loadPdf()
      } else {
        this.cleanup()
      }
    }
  },
  beforeDestroy () {
    this.cleanup()
  },
  methods: {
    close () {
      this.$emit('input', false)
    },
    cleanup () {
      if (this.objectUrl) {
        URL.revokeObjectURL(this.objectUrl)
        this.objectUrl = null
      }
      this.pdfUrl = null
      this.loading = false
    },
    loadPdf () {
      if (!this.documentItem) {
        this.pdfUrl = null
        return
      }
      if (this.documentItem.file && typeof this.documentItem.file === 'string' && this.documentItem.file.startsWith('http')) {
        this.pdfUrl = this.documentItem.file
        return
      }
      if (this.documentItem.file && typeof this.documentItem.file === 'string' && this.documentItem.file.startsWith('data:')) {
        this.pdfUrl = this.documentItem.file
        return
      }
      this.fetchPdf()
    },
    fetchPdf () {
      this.loading = true
      this.$store.dispatch('supportingDocuments/RETRIEVE', {
        resource: 'supporting-documents/documents',
        id: this.documentItem.id,
        detail: 'pdf',
        setDetail: false,
        loader: false
      })
      .then((response) => {
        const base64 = response.data.file
        if (!base64) {
          this.pdfUrl = null
          return
        }
        const byteCharacters = atob(base64)
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        const blob = new Blob([byteArray], { type: 'application/pdf' })
        this.objectUrl = URL.createObjectURL(blob)
        this.pdfUrl = this.objectUrl
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          this.$dialog.message.error(this.parseErrors(error.response.data))
        }
        this.pdfUrl = null
      })
      .finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
